import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/themes.css';
import './styles/journal-layout.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { replaceLegacyBase, isApiUrl } from './config/api';

/*
  Инициализация темы (как было у вас ранее).
*/
const SYSTEM_DARK = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
function applyTheme(themeName) {
  let name = themeName || localStorage.getItem('theme') || 'insrv';
  if (name === 'auto') {
    name = SYSTEM_DARK && SYSTEM_DARK.matches ? 'dark' : 'insrv';
  }
  document.documentElement.setAttribute('data-theme', name);
}
function setTheme(themeName) { localStorage.setItem('theme', themeName); applyTheme(themeName); }
function getTheme() { return localStorage.getItem('theme') || 'insrv'; }
applyTheme(getTheme());
if (SYSTEM_DARK) {
  const onSystemThemeChange = () => {
    if ((localStorage.getItem('theme') || 'insrv') === 'auto') applyTheme('auto');
  };
  if (SYSTEM_DARK.addEventListener) SYSTEM_DARK.addEventListener('change', onSystemThemeChange);
  else if (SYSTEM_DARK.addListener) SYSTEM_DARK.addListener(onSystemThemeChange);
}
window.addEventListener('storage', (e) => { if (e.key === 'theme') applyTheme(e.newValue || 'insrv'); });
window.Inserv = {
  setTheme, getTheme,
  setAdmin: (v = true) => { if (v) localStorage.setItem('isAdmin','1'); else localStorage.removeItem('isAdmin'); }
};

// ==== Глобальный перехват fetch: добавляем Authorization, редирект на /login при 401
(function patchFetchForAuth(){
  const origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!origFetch) return;
  const RequestCtor = typeof Request !== 'undefined' ? Request : null;

  const rewriteResource = (resource) => {
    if (!resource) return resource;
    if (typeof resource === 'string') return replaceLegacyBase(resource);
    if (RequestCtor && resource instanceof RequestCtor) {
      const newUrl = replaceLegacyBase(resource.url);
      if (newUrl === resource.url) return resource;
      return new RequestCtor(newUrl, resource);
    }
    if (typeof resource === 'object' && typeof resource.url === 'string') {
      const newUrl = replaceLegacyBase(resource.url);
      if (newUrl === resource.url) return resource;
      return RequestCtor ? new RequestCtor(newUrl, resource) : newUrl;
    }
    if (typeof resource === 'object' && typeof resource.href === 'string') {
      const newHref = replaceLegacyBase(resource.href);
      if (newHref !== resource.href) return newHref;
    }
    return resource;
  };

  window.fetch = async function(input, init = {}) {
    const rewrittenInput = rewriteResource(input);
    const url = (typeof rewrittenInput === 'string')
      ? rewrittenInput
      : (rewrittenInput?.url || rewrittenInput?.href || '');
    const opts = { ...(init || {}) };
    const token = localStorage.getItem('authToken');
    if (isApiUrl(url) && token) {
      const h = new Headers(opts.headers || {});
      if (!h.has('Authorization')) h.set('Authorization', `Bearer ${token}`);
      opts.headers = h;
    }
    const resp = await origFetch(rewrittenInput, opts);
    if (resp.status === 401) {
      // сброс токена и редирект на логин
      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
      try {
        const loc = window.location;
        if (!loc.pathname.startsWith('/login')) {
          const from = encodeURIComponent(loc.pathname + loc.search);
          window.location.href = `/login?from=${from}`;
        }
      } catch {}
    }
    return resp;
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();